// https://codepen.io/GreenSock/pen/qBrRaeX
const angebote = gsap.utils.toArray('.angebot__angebot');
angebote.forEach((angebot, index) => {
    woerter = angebot.querySelectorAll('.angebot__woerter');
    gsap.to(woerter, {
        scrollTrigger: {
            // markers: {
            //     startColor: "green",
            //     endColor: "red",
            //     fontSize: "12px"
            // },
            trigger: angebot,
            start: 'top 100%',
            end: 'top 40%',
            invalidateOnRefresh: true,
            onLeave: () => angebot.classList.add('aktiv'),
            onLeaveBack: () => angebot.classList.remove('aktiv'),
        }
    });
});

document.getElementById('angebot__so').addEventListener('click', function() {
    var angebotTop = document.getElementById('angebot__angebote').getBoundingClientRect().top + window.scrollY;
    var ziel = angebotTop - (window.innerHeight / 3);
    window.scrollTo({
        top: ziel,
        left: 0,
        behavior: 'smooth'
    });
});